import { render, staticRenderFns } from "./svipServiceAgreement.vue?vue&type=template&id=78c4bdf4&scoped=true"
import script from "./svipServiceAgreement.vue?vue&type=script&lang=js"
export * from "./svipServiceAgreement.vue?vue&type=script&lang=js"
import style0 from "./svipServiceAgreement.vue?vue&type=style&index=0&id=78c4bdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4bdf4",
  null
  
)

export default component.exports